
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import { Separator } from '@/components/ui/separator';

interface CaseStudy {
  id: number;
  title: string;
  description: string;
  image: string;
}

interface BespokeCaseStudiesProps {
  caseStudies: CaseStudy[];
}

const BespokeCaseStudies: React.FC<BespokeCaseStudiesProps> = ({ caseStudies }) => {
  return (
    <section className="py-20 bg-forti-fi-background" aria-labelledby="case-studies-heading">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center mb-12">
          <div className="h-0.5 bg-gold w-20 mb-4"></div>
          <h2 id="case-studies-heading" className="text-3xl md:text-4xl font-serif text-forti-fi text-center mb-6">
            Case Studies
          </h2>
          <p className="text-lg text-center text-forti-fi-charcoal max-w-3xl mb-12">
            Explore how we've designed and implemented custom security solutions for unique properties and challenges.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {caseStudies.map((study) => (
            <AnimateInView key={study.id} animation="scale-in" delay={study.id * 100} className="group">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow h-full">
                <div className="aspect-video overflow-hidden">
                  <img 
                    src={study.image} // Use the image path from the case study data
                    alt={study.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-serif text-forti-fi mb-3">{study.title}</h3>
                  <p className="text-forti-fi-charcoal mb-4">{study.description}</p>
                  <Button variant="link" className="p-0 text-forti-fi group-hover:underline flex items-center gap-2">
                    Read more <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </div>
            </AnimateInView>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BespokeCaseStudies;
